const TopDestinations = () => {
    return ( <></> )
}

export default TopDestinations